import React from "react";

const Gram = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Gram</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
         <table className="table table-striped table-bordered">
         <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>C-235 [Released in 30.06.1973]</strong>
              </td>
            </tr>
            <tr>
              <td>16 to 18 kgs per acre</td>
              <td>2nd week of October</td>
              <td>Just after flowering</td>
              <td>155 days</td>
              <td>
                Brownish yellow grains. Resistant to blite. Susptible to wilt.
                Suitable for irrigated areas.
              </td>
              <td>8 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>HARAYANA CHANA NO. 1 [Released in 15.05.1990]</strong>
              </td>
            </tr>
            <tr>
              <td>20 to 22 kgs per acre</td>
              <td>Up to end of October</td>
              <td>Just after flowering</td>
              <td>150-155 days</td>
              <td>
                Yellow grains. Dwarf variety. Resistant to dry root rot &amp;
                foot root. Suitable for irrigated &amp; rainfed areas of Haryana
                State.
              </td>
              <td>8 to 9 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>HARYANA CHANA NO. 3</strong>
              </td>
            </tr>
            <tr>
              <td>20 to 22 kgs per acre</td>
              <td>Suitable for early sowing</td>
              <td>Just after flowering</td>
              <td>160 to 166 days</td>
              <td>
                Suitable for irrigated, blite &amp; wilt disease sufferer areas.
                Hard &amp; bold stem. Light brown grain. Attracts good market
                price. Resistant to pod borer.
              </td>
              <td>8 to 9 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>HC-5 [Released in 05.11.2005]</strong>
              </td>
            </tr>
            <tr>
              <td>24 to 26 kgs per acre</td>
              <td>Suitable for early and late sowing</td>
              <td>Just after flowering</td>
              <td>140 days</td>
              <td>
                Suitable for irrigated areas. Lodging resistant. Gives more
                yield with dense sowing. Resistant to wilt &amp; root rot.
              </td>
              <td>12 quintals per acre</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Gram;
